module.exports = __webpack_public_path__ + "img/四川天府新区煎茶幼儿园.946b3de0.jpg";